import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LiveStreaming } from '../interface/liveStreaming';
import { OddsAPI } from '../apis/odds/index';

const initialState = {} as LiveStreaming;

export const getLiveStreamUrl = createAsyncThunk(
  'liveStreaming/getLiveStreamUrl',
  async ({ MatchGroupID, LiveID, token }: { MatchGroupID: string; LiveID: string; token: string }) => {
    return await OddsAPI.getLiveStreamURL({ MatchGroupID, LiveID, token });
  }
);

export const getLiveChat = createAsyncThunk(
  'liveStreaming/getLiveChat',
  async ({ type, key, token, merchant }: { type: string; key: string; token: string; merchant: string }) => {
    try {
      return await OddsAPI.getLiveChat({ type, key, token, merchant });
    } catch (_) {
      return '';
    }
  }
);

export const liveStreamingSlice = createSlice({
  name: 'liveStreaming',
  initialState,
  reducers: {
    resetLiveStreaming: (state) => {
      state.Url = '';
      state.isLoading = false;
      state.MatchGroupID = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLiveStreamUrl.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getLiveStreamUrl.fulfilled, (state, action) => {
        state.Url = action.payload;
        state.isLoading = false;
        state.MatchGroupID = action.meta.arg.MatchGroupID;
      })
      .addCase(getLiveChat.fulfilled, (state, action) => {
        state.LiveChat = action.payload;
      });
  },
});

export const { resetLiveStreaming } = liveStreamingSlice.actions;

export default liveStreamingSlice.reducer;
